import * as CONSTANTS from '../constants/constants';

export const getPP = () => (
  dispatch,
  getState,
  { getFirestore }
) => {
  // console.log(userId)
  const firestore = getFirestore();
  const ppRef = firestore.collection(CONSTANTS.THEME).doc('privacypolicy');
  
  ppRef.get().then((snapshot) => {
    const ppContent = Object.assign(snapshot.data(), { id: snapshot.id });
    dispatch({ type: CONSTANTS.GET_PP, ppContent });
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
};

export const updatePP = (ppData) => (
  dispatch,
  getState,
  { getFirestore }
) => {
  dispatch({ type: CONSTANTS.UPDATE_PP });
  const firestore = getFirestore();
  const ppRef = firestore.collection(CONSTANTS.THEME).doc('privacypolicy');
  ppRef.update({
    content: ppData.content,
    dateUpdated: Date.now()
  }).then((data) => {
    dispatch({ type: CONSTANTS.UPDATE_PP_SUCCESS });
  }).catch((err) => {
    console.log('error', err)
  })
};